import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../../components/dashboard';
import { OrganizationForm } from '../../components/organizations/OrganizationForm';
import { organizationService } from '../../services/organizationService';
import { CreateOrganizationDto } from '../../types/organization';
import { upsertInfluenceScores } from '../../services/influencesService';
import { Page, PageHeader } from '../../components/ui';

export const OrganizationCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [scores, setScores] = useState<{ categoryId: string; score: number }[]>([]);

  const handleCreate = async (data: Partial<CreateOrganizationDto>) => {
    setSubmitting(true);
    const payload: CreateOrganizationDto = {
      name: (data.name ?? '').trim(),
      type: (data.type ?? '').trim(),
      description: data.description || undefined,
      email: data.email || undefined,
      phone: data.phone || undefined,
      address: data.address || undefined,
      website: data.website || undefined,
      parentId: data.parentId || undefined,
      acronym: data.acronym || undefined,
      aliases: data.aliases?.length ? data.aliases : undefined,
    };
    const created = await organizationService.createOrganization(payload);
    if (scores && scores.length) {
      try { await upsertInfluenceScores('organization', created.id, scores); } catch (e) {}
    }
    navigate(`/organizations/${created.id}`);
    setSubmitting(false);
  };

  return (
    <DashboardLayout>
      <Page>
        <div className="mx-auto max-w-3xl">
          <PageHeader back={{ to: '/organizations', label: 'Organizations' }} title="New organization" />
          <OrganizationForm
            onSubmit={handleCreate}
            onCancel={() => navigate('/organizations')}
            influenceScores={scores}
            onInfluenceScoresChange={setScores}
            isLoading={submitting}
          />
        </div>
      </Page>
    </DashboardLayout>
  );
};
